// ============================================================
// WidgetContainer Component
// ============================================================
// Base container for all dashboard widgets (charts, lists, etc).

import { Box, Typography, Divider } from '@mui/material';
import { tokens } from '@/theme/tokens';

export function WidgetContainer({ title, action, children, noPadding = false, sx = {} }) {
  return (
    <Box
      sx={{
        backgroundColor: tokens.colors.card,
        borderRadius: tokens.radius.xl,
        boxShadow: tokens.shadows.sm,
        border: `1px solid ${tokens.colors.border}`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        height: '100%',
        ...sx,
      }}
    >
      {(title || action) && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2.5,
            }}
          >
            {title && (
              <Typography variant="h6" fontWeight={600}>
                {title}
              </Typography>
            )}
            {action && <Box>{action}</Box>}
          </Box>
          <Divider sx={{ borderColor: tokens.colors.border }} />
        </>
      )}
      
      <Box sx={{ p: noPadding ? 0 : 2.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Box>
  );
}
